import { Api } from '@ih/app/shared/apis/interfaces';

export class SetApis {
  public static readonly type = '[Project/Api/List] SetApis';
  constructor(public readonly apis: Api[]) {}
}
